import React, {Component} from "react";
import {Row, Col, Collapse} from 'reactstrap';
import '../Review.css';

export default class ReviewMapSexualOrientation extends Component {

    constructor(props) {
       super(props);
       this.state = {
           isMapSexualOrientationOpened: false
       }
    }

    getSexualOrientationDisplayValue = (sexualOrientation) => {
        let mappedSexualOrientation = this.props.mapOptions.filter(option => option.label === sexualOrientation.label);
        if (mappedSexualOrientation.length > 0)
            return mappedSexualOrientation[0].label;
        else
            return '';
    }

    render() {
        let { allSexualOrientationMapping } = this.props.mapSexualOrientation;
        let {isMapSexualOrientationOpened} = this.state;
        let noOfSexualOrientationTypesMapped = allSexualOrientationMapping.filter(sexualOrientationMapping => sexualOrientationMapping.column!=="").length;
        
        return (<div className="review-sub-section">
            <Row>
                <Col sm="11" md="11" className="review-sub-section-heading">Mapped {noOfSexualOrientationTypesMapped} of {allSexualOrientationMapping.length} values to sexual orientation categories</Col>
                <Col sm="1" md="1" className={isMapSexualOrientationOpened ? 'rotate-arrow' : 'text-center'}>
                    <i className={(isMapSexualOrientationOpened ? 'flaticon-down-arrow ' : 'flaticon-down-arrow').concat(' review-flaticon-down-arrow cursor-pointer')}
                        onClick={() => {
                            this.setState({ isMapSexualOrientationOpened: !isMapSexualOrientationOpened });
                        }} />
                </Col>
            </Row>
            <Collapse isOpen={isMapSexualOrientationOpened}>
                 <div className="mt30 mapped-review-records">
                   {allSexualOrientationMapping.map((mappedSexualOrientation, index) => {
                        return (<div key={index} className={'review-mapped-column '.concat(index === 0 ? ' ' : 'mt10')}>
                            <span style={{ fontWeight: '600' }}>
                            {!mappedSexualOrientation.value || mappedSexualOrientation.value===undefined||mappedSexualOrientation.value===null ||mappedSexualOrientation.value==="null"|| mappedSexualOrientation.value==="undefined"? 
                                mappedSexualOrientation.value="empty"
                                :
                                mappedSexualOrientation.value
                                } Sexual Orientation type
                            </span>
                             {mappedSexualOrientation.column!=="" &&mappedSexualOrientation.column!==null ? <span><span> mapped to </span>
                            <span style={{ fontWeight: '600' }}>{this.getSexualOrientationDisplayValue(mappedSexualOrientation.column)}</span>
                            </span>: <span> left unmapped</span>}
                        </div>
                        )
                    })}
                </div> 
            </Collapse>
        </div>
                )
    }
}
